<template>
    <div class="container">
    
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-10">

                <div class="panel">
                    <div class="panel-header">
                        <div class="row">
                            <div class="col-lg-6 col-md-6" style="padding-top:7px;">
                                Engenheiros
                            </div>
                            <div class="col-lg-6 col-md-6 right">
                                <router-link class="btn-sm btn-success" :to="{name:'NovoEngenheiro'}">Novo engenheiro</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="panel-content">

                        
                        <div class="item" v-for="eng in engs" v-bind:key="eng.id">
                            <router-link :to="{name:'editarEngenheiro',params:{id:eng.id}}">
                            <strong>{{eng.nome}}</strong>
                            <p style="margin-bottom:0px;">
                                {{eng.email}}<br>
                                {{eng.cpf}}
                            </p>
                            </router-link>
                        </div>
                        

                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import config from '@/config'

export default {
    name:"Engenheiros",
    data(){
        return{
            config:config,
            engs:{}
        }
    },
    methods:{
        Listar(){
            this.$http.get(this.config.API+'engs')
            .then(res => {
                this.engs = res.data.data
                console.log('engenheiros',res.data.data)
            })
        }
    },
    beforeMount(){
        this.Listar()
    }
}
</script>

<style scoped>
    .item a, .item a:hover{
        color: initial;
        text-decoration: none !important;
    }
</style>